import coverImg from "assets/images/v114/cover.webp"

export const v114Config = {
  cover: {
    en: coverImg,
  },
}
